// Enum for the different setting types
const settingTypes = {
  FREETEXT: 'FREETEXT',
  BOOLEAN: 'BOOLEAN',
  NUMBER: 'INT',
  JSON: 'JSON',
}

export default settingTypes
